<mat-form-field class="user-picker" appearance="fill">
  <mat-label>{{ label }}</mat-label>
  <input type="text"
         matInput
         [formControl]="searchControl"
         [matAutocomplete]="auto"
         placeholder="Search by name or email">
  <mat-autocomplete #auto="matAutocomplete"
                    [displayWith]="display"
                    (optionSelected)="onSelected($event)">
    <mat-option *ngFor="let user of filteredUsers$ | async" [value]="user">
      <span class="user-option">
        <img class="user-option__avatar" *ngIf="user.photoURL" [src]="user.photoURL" alt="">
        <span class="user-option__text">
          <span class="user-option__name">{{ user.displayName || user.email }}</span>
          <span class="user-option__email" *ngIf="user.displayName">{{ user.email }}</span>
        </span>
      </span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
